import React from "react";
import styled, { css } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { XSmall } from "@vitalsource/vstui-icons";
import { t } from "../../core/translate";
import { fadeInOut } from "../mixins";

// Set to true to see arrow boxes more clearly
const DEBUG_ARROW = false;

// Initial size of box to use as arrow base
const ARROW_BASE_LENGTH = 22;

const Styled = {};

Styled.Arrow = styled.div`
  position: absolute;
  width: ${ARROW_BASE_LENGTH}px;
  height: ${ARROW_BASE_LENGTH}px;
  z-index: -1;
  /* How far outside the box to pull the arrow */
  top: -8px;
  ${DEBUG_ARROW &&
  css`
    background: red;
  `};

  &:before {
    position: absolute;
    background: white;
    width: ${ARROW_BASE_LENGTH}px;
    height: ${ARROW_BASE_LENGTH}px;
    content: "";
    transform: rotate(45deg) skew(10deg, 10deg);
    transform-origin: center center;
    border-radius: 3px;

    ${DEBUG_ARROW &&
    css`
      background: blue;
    `};
  }
`;

Styled.Box = styled.div`
  background-color: white;
  border-radius: 4px;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4));
  padding: 16px 19px;
  font-size: 1.4rem;
  line-height: 1.8rem;
  ${p => fadeInOut(p.isOpen, { inDelayMS: 1500 })};
  color: ${cloud.getShade(10)};
  font-weight: normal;
  text-align: left;
`;

Styled.CloseButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

const CloseButton = createThemedComponent(Button, {
  Button_paddingHorizontal_withIconSmall: "10px",
  Button_color_neutralNaked: cloud.getShade(6)
});

/**
 * Derived from supernova's BonusInfoBox
 */
class PopoverBox extends React.Component {
  state = {
    hasMounted: false
  };

  componentDidMount() {
    // If the component mounts with isOpen = true, the fade transition won't run
    // Correct for this by forcing an initial closed render
    this.setState({ hasMounted: true });
  }

  render() {
    let {
      children,
      isOpen,
      onClose,
      maxWidth,
      className,
      targetOffset,
      arrowOffset,
      boxOffset
    } = this.props;
    return (
      <Styled.Box
        isOpen={this.state.hasMounted && isOpen}
        style={{ left: targetOffset + boxOffset, maxWidth }}
        role="alert"
        className={className}
      >
        <Styled.CloseButtonContainer>
          <CloseButton
            iconStart={<XSmall />}
            label={t("base.close", "Close")}
            size="small"
            onClick={onClose}
            color="neutral"
            naked
          />
        </Styled.CloseButtonContainer>
        {children}
        <Styled.Arrow style={{ left: arrowOffset - boxOffset - 16 }} />
      </Styled.Box>
    );
  }
}

export default PopoverBox;
